// extracted by mini-css-extract-plugin
module.exports = {"action_sheet":"action_sheet-1sKbz","title":"title-3ONoD","instr":"instr-1UoQm"};